<!--loading spinner-->
<div class="loading-spinner" *ngIf="loadingService.showLoadingSpinner">
    <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<!--loading spinner-->
